import { Component, Renderer2, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute} from '@angular/router';
import { log } from 'console';
import { Router } from '@angular/router';
@Component({
  selector: 'app-bulletinboard',
  templateUrl: './bulletinboard.component.html',
  styleUrls: ['./bulletinboard.component.scss']
})
export class BulletinboardComponent implements OnInit {

  storeDetails = {};
  params = {};
  content = null;
  title = null;
  featureTags = {};
  storedetails1 = {};

  constructor( 
    private apiService : ApiService,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    public router:Router,
    private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.getStoreDetails();
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    this.params['store_id']=this.storeDetails['id'];
    this.params['type']='bulletin_board';
    if (this.featureTags && this.featureTags['ftag_bulletin_board_on_website']) {
      this.storedetails1 = this.route.snapshot.data['store']['response']['data']['store'];
      if(this.storedetails1['enable_bulletin_board'] == false){
        this.router.navigate(['/not-found']); 
        return;
      }
    }
   // this.params['title']='home';
    this.apiService.getContentItems(this.params).subscribe(result => {
      
      if (result['response']['status'] === 1) {
        if (!!result['response']['data'][0]['content']) {
          if (this.featureTags && this.featureTags['ftag_sf_bulletin_issue']) {
            let contentMessage=result['response']['data'][0]['content'] !="" ? result['response']['data'][0]['content'] : "";
            this.content = this.sanitizer.bypassSecurityTrustHtml(contentMessage);
          }else{
            this.content=result['response']['data'][0]['content'] !="" ? result['response']['data'][0]['content'] : "";
          }          
          this.title=result['response']['data'][0]['title'] !="" ? result['response']['data'][0]['title'] : "";
        }
      }
     }, (error) => {
      if (error) {
        console.log(error);
      }
    });

    
   }

  getStoreDetails() {
    this.storeDetails = JSON.parse(sessionStorage.getItem('store'));
  }

}